import React, { Component } from 'react';
import { Provider } from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import ReactGA from 'react-ga';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import injectTapEventPlugin from 'react-tap-event-plugin';

import getMuiTheme from 'material-ui/styles/getMuiTheme';

import './App.css';

import configureStore from './store';

import AppView from './AppView';

import { PRIMARY, SECONDARY } from './components/styles';

const history = createHistory();

history.listen((location) => {
  // analyticsService.track(location.pathname)
  console.log('Google GA - logging page change', location.pathname);
  ReactGA.set({ page: location.pathname + location.search });
  ReactGA.pageview(location.pathname + location.search);
});

ReactGA.initialize('UA-106817069-2');

const initialState = {};
const store = configureStore(initialState, history);

injectTapEventPlugin();

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: PRIMARY,
    accent1Color: SECONDARY,
  },
  appBar: {},
  toolbar: {},
});

class App extends Component {
  componentWillMount() {
    // Add callback for lock's `authenticated` event
    // this.authService.lock.on('authenticated', (authResult) => {
    //   this.props.loggedIn(authResult);
    // });
    // Add callback for lock's `authorization_error` event
    // this.authService.lock.on('authorization_error', (error) => {
    //   this.props.loginError(error);
    //   return this.props.history.push({ pathname: '/' });
    // });
  }

  render() {
    return (
      <Provider store={store}>
        <MuiThemeProvider muiTheme={muiTheme}>
            <AppView history={history}/>
        </MuiThemeProvider>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js